import {Controller} from '@stimulus/core'
import HSQuantityCounter from '../../../../../vendor/front/vendor/hs-quantity-counter/src/js/hs-quantity-counter'

// data-controller='hs--quantity-counter'
// https://htmlstream.com/front/documentation/quantity-counter.html

export default class extends Controller {
  connect() {
    new HSQuantityCounter($(this.element)).init();
  }
}
